export default {
  'get-list': {
    method: 'post',
    url: '/partner/order/list'
  },
  add: {
    method: 'post',
    url: '/partner/order'
  },
  delete: {
    method: 'delete',
    url: '/partner/order'
  },
  update: {
    method: 'put',
    url: '/partner/order/ID'
  },
  updatePatch: {
    method: 'patch',
    url: '/partner/order/ID'
  },
  detail: {
    method: 'get',
    url: '/partner/order/ID'
  },
  changeStatus: {
    method: 'put',
    url: '/partner/order/status'
  },
  select: {
    method: 'get',
    url: '/partner/order/find?key=KEY'
  },
  'calculate-shipping-plan': {
    method: 'post',
    url: '/partner/order/calculate-shipping-plan'
  },
  'calculate-shipping-plan-manual': {
    method: 'post',
    url: '/partner/order/calculate-shipping-plan-manual'
  },
  'create-teamplate-shipping-plan': {
    method: 'post',
    url: '/partner/order/create-teamplate-shipping-plan'
  },
  'quote-by-customer-request': {
    method: 'post',
    url: '/partner/order/quote-by-customer-request'
  },
  'add-by-request': {
    method: 'post',
    url: '/partner/order/add-by-request'
  },
  'add-document': {
    method: 'POST',
    url: '/partner/order/document/upload'
  },
  'delete-document': {
    url: '/partner/order/document/delete',
    method: 'DELETE'
  },
  'edit-document': {
    url: '/partnerorder/document/file/ID',
    method: 'PUT'
  },
  archive: {
    method: 'delete',
    url: '/partner/order/archive'
  },
  restore: {
    method: 'put',
    url: '/partner/order/restore'
  },
  searchQuote: {
    method: 'get',
    url: '/partner/order/search-quote/ID'
  },
  addQuoteToOrder: {
    method: 'post',
    url: '/partner/order/add-quote/ID'
  },
  editQuoteToOrder: {
    method: 'put',
    url: '/partner/order/edit-quote/ID'
  },
  cancel: {
    method: 'put',
    url: '/partner/order/ID/cancel'
  },
  addContainerNumbers: {
    method: 'post',
    url: '/partner/order/ID/container-number'
  },
  getContainerNumbers: {
    method: 'get',
    url: '/partner/order/ID/container-number'
  },
  addContainerNumber: {
    method: 'post',
    url: '/partner/order/ID/container-one-number'
  }
}
